class UtilityFunctions {
  /**
   * Sets the Download Arxena App link href with arch and format query params (matches ArxDownloadModal endpoint).
   * Call after search page content is injected so #download_arxena_app_link exists.
   */
  initDownloadArxenaAppLink() {
    var link = document.getElementById("download_arxena_app_link");
    if (!link) return;
    var ua = (typeof navigator !== "undefined" && navigator.userAgent) ? navigator.userAgent.toLowerCase() : "";
    var platform = (typeof navigator !== "undefined" && navigator.platform) ? navigator.platform.toLowerCase() : "";
    var os = "unknown";
    if (ua.indexOf("mac os x") !== -1 || ua.indexOf("macintosh") !== -1 || ua.indexOf("darwin") !== -1) os = "darwin";
    else if (ua.indexOf("windows") !== -1 || ua.indexOf("win64") !== -1 || ua.indexOf("win32") !== -1) os = "windows";
    else if (ua.indexOf("linux") !== -1 || ua.indexOf("x11") !== -1 || ua.indexOf("ubuntu") !== -1 || ua.indexOf("fedora") !== -1 || ua.indexOf("debian") !== -1) os = "linux";
    var arch = "x64";
    if (platform.indexOf("arm") !== -1 || ua.indexOf("arm") !== -1 || ua.indexOf("aarch64") !== -1) arch = "arm64";
    else if (platform.indexOf("x64") !== -1 || platform.indexOf("x86_64") !== -1 || platform.indexOf("amd64") !== -1 || ua.indexOf("x64") !== -1 || ua.indexOf("x86_64") !== -1 || ua.indexOf("amd64") !== -1) arch = "x64";
    var format = "";
    if (os === "darwin") format = "dmg";
    else if (os === "linux") format = "appimage";
    else if (os === "windows") format = "exe";
    if (format) link.href = "/download-app?arch=" + encodeURIComponent(arch) + "&format=" + encodeURIComponent(format);
  }

  copyAuthToken() {
    console.log("This is the copy auth token called");
    var copyText = document.getElementById("auth_token_input");
    navigator.clipboard.writeText(copyText.value).then(
      function () {
        alert("Auth token copied to clipboard");
      },
      function (err) {
        console.error("Could not copy text: ", err);
      }
    );
  }
  getNextWorkingDay(inc = 1) {
    inc = inc <= 0 ? 1 : inc;
    const currentDate = new Date();
    const currentDay = currentDate.getDay(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday

    // Check if the current day is Friday
    if (currentDate.getDay() === 0) {
      // Sunday
      // If it's Sunday, add 1 day to set it to Monday
      currentDate.setDate(currentDate.getDate() + 1);
    } else if (currentDay === 5) {
      // Friday
      // If it's Friday, add 3 days to skip Saturday and Sunday
      currentDate.setDate(currentDate.getDate() + 3);
    } else if (currentDate.getDay() === 6) {
      // Saturday
      // If it's Saturday, add 2 days to set it to Monday
      currentDate.setDate(currentDate.getDate() + 2);
    } else {
      // For other days, add 1 day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Set the time to 10:00 AM
    // currentDate.setHours(10, 0, 0, 0);

    // Check if it's already past 6:00 PM, if so, set it to next day 10:00 AM
    if (currentDate.getHours() >= 18) {
      currentDate.setDate(currentDate.getDate() + 1);
      currentDate.setHours(10, 0, 0, 0);
    } else {
      // Increment time by 30 minutes
      currentDate.setMinutes(currentDate.getMinutes() + 30 * inc);
    }

    return currentDate.toISOString();
  }

  clearRadioDataCoverageButtons() {
    try {
      var radio_data_coverage = document.querySelector("input[type=radio][name=dataCoverageRadios]:checked");
      if (radio_data_coverage) {
        radio_data_coverage.checked = false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
    try {
      var radio_data_source = document.querySelector("input[type=radio][name=dataSourceRadios]:checked");
      if (radio_data_source) {
        radio_data_source.checked = false;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  dateTimetoHumanString(datetime_string) {
    const dateString = datetime_string;
    const dateObj = new Date(dateString + " UTC");
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = dateObj.getUTCDate();
    const month = months[dateObj.getUTCMonth()];
    const year = dateObj.getUTCFullYear();
    const hour = dateObj.getUTCHours();
    const minute = dateObj.getUTCMinutes();
    const humanReadable = `${month} ${day}, ${year}; ${hour}:${minute < 10 ? "0" + minute : minute}`;
    return humanReadable;
  }
  truncateString = (str, num) => (str.length <= num ? str : `${str.slice(0, num)}...`);

  runNavigation() {
    if (window.location.href.indexOf("/signup") >= 0) {
      sessionStorage["navigation_history"] = ",/signup";
      new PageContents().setLogonStatus();
      new ProcessNodesStates().initializeSessionStorageforDropdowns();
      new Pages().signupPage();
    } else if (window.location.href.indexOf("/login") >= 0) {
      sessionStorage["navigation_history"] = ",/login";
      console.log("document ready login");
      new ProcessNodesStates().initializeSessionStorageforDropdowns();
      new PageContents().setLogonStatus();
      new Pages().loginPage();
    } else if (window.location.href.indexOf("/privacy") >= 0) {
      sessionStorage["navigation_history"] = ",/privacy";
      new PageContents().setLogonStatus();
      new Pages().privacyPage();
    } else if (window.location.href.indexOf("/eula") >= 0) {
      sessionStorage["navigation_history"] = ",/eula";
      new PageContents().setLogonStatus();
      new Pages().eulaPage();
    } else if (window.location.href.indexOf("/api") >= 0) {
      sessionStorage["navigation_history"] = ",/api";
      console.log(" document ready function of /api");
      new PageContents().setLogonStatus();
      new Pages().apiPage();
    } else if (window.location.href.indexOf("/people") >= 0) {
      sessionStorage["navigation_history"] = ",/people";
      console.log(" document ready function of /people");
      new PageContents().setLogonStatus();
      new Pages().searchPage();
    } else if (window.location.href.indexOf("/companies") >= 0) {
      sessionStorage["navigation_history"] = ",/companies";
      new PageContents().setLogonStatus();
      console.log(" document ready function of /companies");
      new Pages().searchPage();
    } else if (window.location.href.indexOf("/pricing") >= 0) {
      new PageContents().setLogonStatus();
      sessionStorage["navigation_history"] = ",/pricing";
      console.log(" document ready function of /pricing");
      new Pages().pricingPage();
    } else if (window.location.href.indexOf("/lists") >= 0) {
      new PageContents().setLogonStatus();
      sessionStorage["navigation_history"] = ",/lists";
      console.log(" document ready function of /lists");
      // new Pages().listsPage();
      new Pages().searchPage();
    } else if (window.location.href.indexOf("/tables") >= 0) {
      new PageContents().setLogonStatus();
      sessionStorage["navigation_history"] = ",/tables";
      console.log(" document ready function of /tables");
      new Pages().tablesPage();
    } else if (window.location.href.indexOf("/plans") >= 0) {
      new PageContents().setLogonStatus();
      sessionStorage["navigation_history"] = ",/plans";
      console.log(" document ready function of /plans");
      new Pages().listsPage();
    } else if (window.location.href.indexOf("/home") >= 0) {
      new PageContents().setLogonStatus();
      sessionStorage["navigation_history"] = ",/home";
      console.log(" document ready function of /home");
      new Pages().landingPage();
    } else if (window.location.href.indexOf("/dashboard") >= 0) {
      // let's check if they are trying to enter the home page -> /app/user_id
      // ...or if instead this is part of a longer analysis link
      // metadata = window.location.href.slice(window.location.href.indexOf("/app/")+5 , window.location.href.length)
      // console.log('metadata of /dashboard funciton, created from a slice of /app/')
      // metadata = metadata.slice(0,24)
      // console.log("This is the metadata ", metadata)
      // console.log("dashboard from document ready function");
      new PageContents().setLogonStatus();
      if (localStorage["user_id"] != null) {
        console.log("This is the metadata");
        // console.log(metadata);

        sessionStorage["navigation_history"] = ",/#";
        // drift_append_email()
        new PageContents().changePage("/dashboard");
      } else {
        new Pages().resetLocalStorageCredentialsAndSetLogonStatus();
        // localStorage['email'] = ''
        // localStorage['first_name'] = ''
        // localStorage['full_name'] = ''
        // localStorage['last_name'] = ''
        // localStorage['user_id'] = ''
        // localStorage['user'] = '{}'
        localStorage["useraccount_id"] = "";
        localStorage["google_sheet_id"] = "";
        sessionStorage["navigation_history"] = ",/#";
        // setLogonStatus()
        new PageContents().changePage("/login");
      }
    } else if (window.location.href.indexOf("/org-chart/") > 0) {
      console.log("GOT org-chart call function!!");
      console.log("Current sessionStorage LOAD TYPE::", sessionStorage["load_type"]);
      // console.log(localStorage['user_id'])
      var company_id = window.location.href.slice(window.location.href.indexOf("/org-chart/") + 11, window.location.href.length);

      sessionStorage["navigation_history"] = ",/#";
      new PageContents().setLogonStatus();
      // new ProcessNodesStates().resetSessionStorageforDropdowns()
      // sessionStorage['company_id'] = company_id
      console.log(sessionStorage);
      var updateTokenObj = {};
      updateTokenObj["token_to_be_updated"] = "company_id";
      updateTokenObj["updated_value"] = company_id;
      updateStorageToken(updateTokenObj, "endpoint");
      if (sessionStorage["load_type"] != "org-chart") {
        new PageContents().changePage("/org-chart");
      }

      // fetchQueryShowResults();
      // } else if (window.location.href.indexOf("/share/") >= 0){
      //     // let's check if they are trying to enter a shared org chart -> /share/org_data_id
      //     point_id = window.location.href.slice(window.location.href.indexOf("/share/")+7 , window.location.href.length)
      //     sessionStorage['navigation_history']=',/#'
      //     sessionStorage['point_id'] = point_id
      //     changePage('/share')

      // } else if (window.location.href.indexOf("/invite/") >= 0){
      //     // this is a referral link
      //     metadata = window.location.href.slice(window.location.href.indexOf("/invite/")+8 , window.location.href.length)
      //     sessionStorage['navigation_history']=',/#'
      //     sessionStorage['referrer_id'] = metadata.slice(0, 32)
      //     changePage('/signup')
    } else if (window.location.href.indexOf("/password_reset_link/") >= 0) {
      new PageContents().setLogonStatus();
      // this is a referral link
      var metadata = window.location.href.slice(window.location.href.indexOf("/password_reset_link/") + 21, window.location.href.length);

      sessionStorage["navigation_history"] = ",/#";
      sessionStorage["reset_token_id"] = metadata;
      new PageContents().changePage("/password_reset_link");
    } else if (window.location.href.indexOf("/password_reset") >= 0) {
      sessionStorage["navigation_history"] = ",/password_reset";
      new PageContents().setLogonStatus();
      new PasswordReset().passwordResetPage();
    } else {
      console.log("Cant allocate any specific URL to page. Going to home page");
      sessionStorage["navigation_history"] = "";
      new PageContents().setLogonStatus();
      new PageContents().changePage("/#");
    }
  }

  setUPSessionStorageVariables() {
    sessionStorage["screen_width"] = $(window).width();
    sessionStorage["request_time"] = 3000;
    sessionStorage["table_data_sources"] = "[]";
    sessionStorage["consume_credits"] = "false";
    sessionStorage["query"] == "{}";
    sessionStorage["prompt_enum_list"] = "[]";
    sessionStorage["fetch_people_data_count"] = 0;
    sessionStorage["job_name"] = "";
    sessionStorage["fetch_companies_data_count"] = 0;
    sessionStorage["fetch_nodes_data_count"] = 0;
    sessionStorage["comboTree"] = "";
    sessionStorage["raw_string_query_input"] = "";
    sessionStorage["load_type"] = document.getElementById("load_type").getAttribute("data-row");
    // sessionStorage['nodes_accessed'] = '[]'
    sessionStorage["upload_type_jd_cv"] = "";
    sessionStorage["payment_plans"] = document.getElementById("payment_plans").getAttribute("data-row");
    sessionStorage["current_focus"] = "orgcharts";
    sessionStorage["org_node_data"] = "[]";
    sessionStorage["data_coverage"] = "include_phone_and_email";
    sessionStorage["data_source"] = "arxena";
    sessionStorage["boolean_keywords_string"] = "false";
    sessionStorage["contact_info"] = "false";
    sessionStorage["selectFunctionsTreeFunctionsRootItem"] = "";
    sessionStorage["selectFunctionsTreeFunctionsItem"] = "";
    sessionStorage["selectGradesItem"] = "";
    localStorage["csv_excel_data"] = "{}";
    sessionStorage["selected_updated_sublist_candidates"] = "";
    sessionStorage["selected_create_new_sublist_candidates"] = "";
    try {
      sessionStorage["use_case"] = JSON.parse(document.getElementById("user_obj").getAttribute("data-row"))["use_case"];
    } catch (error) {
      sessionStorage["use_case"] = "";
    }
    var raw_text_filters = ["email_address", "person_linkedin_url", "company_id", "person_name", "tags", "website", "person_linkedin_url", "phone_number", "company_linkedin_url", "reverse_job_title", "job_title", "gpt3_company_search"];
    sessionStorage["raw_text_filters"] = JSON.stringify(raw_text_filters);
    sessionStorage["sample_people_data"] = "true";
    sessionStorage["sample_company_data"] = "true";
    sessionStorage["geo_country_selected"] = "US";
    sessionStorage["geo_country_user"] = "";
    sessionStorage["company_emp_counts"] = "[]";
    sessionStorage["selected_context_menu"] = "";
    // sessionStorage['selected_blocks'] = '[]';
    sessionStorage["locations_dropdown1"] = ";";
    sessionStorage["locations_dropdown2"] = "";
    sessionStorage["locations_dropdown3"] = "";
    sessionStorage["company_analytics"] = "";
    sessionStorage["selected_nodes"] = "[]";
    sessionStorage["visitor_fp"] = "";
    sessionStorage["count_cost_credits"] = "";
    sessionStorage["logon"] = "false";
    sessionStorage["count_db_results"] = "";
    // sessionStorage['all_jobs'] = '[]';
    // sessionStorage['current_table'] = '{}'
  }

  detectModalClosuresAndCloseItems() {
    $(fetch_node_results).on("hide.bs.modal", function () {
      document.getElementById("cost_of_credits_org_chart").innerHTML = "";
      new Query().clearSelectedContextMenu();
      new UtilityFunctions().clearRadioDataCoverageButtons();
      updateStorageToken("blank", "cost_of_credits_org_chart");
      sessionStorage["count_db_results"] = 0;
      document.getElementById("modal_locations_dropdown1").innerHTML = "";
      document.getElementById("modal_locations_dropdown2").innerHTML = "";
      document.getElementById("modal_locations_dropdown3").innerHTML = "";
      document.getElementById("pick_function_error_node").innerHTML = "";
      document.getElementById("select_functions_tree_data_dropdown").style.display = "none";
      document.getElementById("select_grades_data_dropdown").style.display = "none";
      sessionStorage["selectFunctionsTreeFunctionsRootItem"] = "";
      sessionStorage["selectFunctionsTreeFunctionsItem"] = "";
      sessionStorage["selectGradesItem"] = "";
      sessionStorage["data_source"] = "arxena";

      // new Tokens().resetFunctionsGradesDropdown()
    });

    $(import_data_modal).on("hide.bs.modal", function () {
      localStorage["csv_excel_data"] = "";
      document.getElementById("column_mapping_interface").style.display = "none";
      $("#filename").val("");
      document.getElementById("file_name_uploaded").innerText = "";
      document.getElementById("completed_upload_file_submission").innerText = "";
    });

    $(enter_query_modal).on("hide.bs.modal", function () {
      sessionStorage["raw_string_query_input"] = "";
      document.getElementById("query_input_errors").innerHTML = "";
      document.getElementById("enter_query_modal_input").value = "";
    });

    $(upload_jdcv_modal).on("hide.bs.modal", function () {
      sessionStorage["upload_type_jd_cv"] = "";

      document.getElementById("pick_upload_jd_cv_error").innerHTML = "";
      document.getElementById("upload_jd_cv_dropdown_selected").innerHTML = "Please select upload type - JD/ CV";
    });

    $(fetch_company_results).on("hide.bs.modal", function () {
      document.getElementById("cost_of_credits_companies").innerHTML = "";
      new UtilityFunctions().clearRadioDataCoverageButtons();
      new Query().clearSelectedContextMenu();
      // sessionStorage['data_source'] = 'arxena'
      // sessionStorage['data_coverage'] = 'only_profiles'
      document.getElementById("modal_locations_dropdown1").innerHTML = "";
      document.getElementById("modal_locations_dropdown2").innerHTML = "";
      document.getElementById("modal_locations_dropdown3").innerHTML = "";
    });

    $(fetch_people_results).on("hide.bs.modal", function () {
      document.getElementById("cost_of_credits_people").innerHTML = "";
      new Query().clearSelectedContextMenu();
      new UtilityFunctions().clearRadioDataCoverageButtons();
      document.getElementById("modal_locations_dropdown1").innerHTML = "";
      document.getElementById("modal_locations_dropdown2").innerHTML = "";
      document.getElementById("modal_locations_dropdown3").innerHTML = "";
    });

    $(waiting_results).on("hide.bs.modal", function () {
      document.getElementById("cost_of_credits_people").innerHTML = "";
      document.getElementById("cost_of_credits_org_chart").innerHTML = "";
      document.getElementById("cost_of_credits_people").innerHTML = "";
      document.getElementById("cost_of_credits_companies").innerHTML = "";

      new Query().clearSelectedContextMenu();
      new UtilityFunctions().clearRadioDataCoverageButtons();
      // sessionStorage['data_source'] = 'arxena'
      // sessionStorage['data_coverage'] = 'only_profiles'
      document.getElementById("modal_locations_dropdown1").innerHTML = "";
      document.getElementById("modal_locations_dropdown2").innerHTML = "";
      document.getElementById("modal_locations_dropdown3").innerHTML = "";
    });
    sessionStorage["data_coverage"] = "include_phone_and_email";
    sessionStorage["data_source"] = "arxena";

    $(edit_uploaded_jd).on("hide.bs.modal", function () {
      sessionStorage["onKeypressInput"] = "";
      document.getElementById("dropdown_list_locations").innerHTML = "";
      document.getElementById("dropdown_list_company_name").innerHTML = "";
      document.getElementById("gpt_search_loading").innerHTML = "";
      let loader = (document.getElementById("modal_edit_jd_error").innerHTML = "");
    });
    $(upload_jd_modal).on("hide.bs.modal", function () {
      document.getElementById("upload_jd_modal_extra_info").innerHTML = "";
      document.getElementById("upload_new_jd_form_err").innerHTML = "";
      document.getElementById("upload_new_jd_file_input").value = "";
    });
    $(create_add_to_sublist_modal).on("hide.bs.modal", function () {
      document.getElementById("add_sub_list_no_records").style.display = "none";
      document.getElementById("sublist_tables_dropdown_elements").innerHTML = "";
      document.getElementById("create_new_sublist").checked = false;
      document.getElementById("add_to_existing_sublist").checked = false;
      document.getElementById("create_new_sublist_create_name").style.display = "none";
      document.getElementById("dropdown_elements_select_table_names").style.display = "none";
      document.getElementById("label_selected_sublist_dropdown").innerText = "Select sublist";
      document.getElementById("loder_add_or_create_sublist").innerText = "";
    });
  }

  takeInputValueAndReturnObject(input_value) {
    var new_obj = {};
    var key_name = "name";
    var additional_key = "exclude";
    var additional_key_default_value = false;
    new_obj[key_name] = input_value;
    if (additional_key != undefined) {
      new_obj[additional_key] = additional_key_default_value;
    }
    return new_obj;
  }

  turnArraytoArrayofObjects(arr) {
    var updated_arr = [];
    for (var i = 0; i < arr.length; i++) {
      // new_obj = {}
      // new_obj[key_name] = arr[i]
      // if (additional_key!= undefined){
      //     new_obj[additional_key] = additional_key_default_value
      // }
      var new_obj = this.takeInputValueAndReturnObject(arr[i]);

      updated_arr.push(new_obj);
    }
    return updated_arr;
  }

  stopLoadersFromRotating() {
    for (var i = 0; i < document.getElementsByClassName("loader-link").length; i++) {
      document.getElementsByClassName("loader-link")[i].innerHTML = "";
    }
  }

  getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }

  triggerFocus(element) {
    var eventType = "onfocusin" in element ? "focusin" : "focus",
      bubbles = "onfocusin" in element,
      event;

    if ("createEvent" in document) {
      event = document.createEvent("Event");
      event.initEvent(eventType, bubbles, true);
    } else if ("Event" in window) {
      event = new Event(eventType, { bubbles: bubbles, cancelable: true });
    }
    element.focus();
    element.dispatchEvent(event);
  }

  scrollToBottom() {
    console.log("scrollToBottom FUNCTION CALLED");
    // $("#orgchart_section").animate({ scrollTop: 500 }, 1000);
    window.scrollTo({ top: 450, behavior: "smooth" });
  }

  auto_grow(element) {
    element.style.height = "25px";
    element.style.height = element.scrollHeight + "px";
  }

  getCountryCode() {
    if (sessionStorage["geo_country_user"] == "" || sessionStorage["geo_country_user"] == undefined) {
      jQuery
        .get("https://ipinfo.io/?token=49074596a34362", function () {}, "jsonp")
        .always(function (resp) {
          var countryCode = resp && resp.country ? resp.country : "us";
          // console.log(resp)
          // console.log("This is the country code that got created::", countryCode)
          sessionStorage["geo_country_user"] = countryCode;
          sessionStorage["ipinfo_resp"] = JSON.stringify(resp);
        });
    }
    var countryCode = sessionStorage["geo_country_user"];
    return countryCode;
  }

  showPlans() {
    $(plans_modal).modal("show");
  }

  setIntPhoneNumbers() {
    var inputs = document.getElementsByClassName("phone_number");
    var iti = {};
    for (var i = 0; i < inputs.length; i++) {
      // console.log("This is the input!:", inputs[i])
      iti[i] = intlTelInput(inputs[i], {
        initialCountry: "auto",
        nationalMode: "false",
        separateDialCode: "true",
        autoHideDialCode: "true",
        preferredCountries: ["us", "gb", "ca", "de", "au", "in", "sg", "ae"],
        geoIpLookup: function (success, failure) {
          jQuery
            .get("https://ipinfo.io/?token=49074596a34362", function () {}, "jsonp")
            .always(function (resp) {
              var countryCode = resp && resp.country ? resp.country : "us";
              // console.log(resp)

              // console.log("This is the country code that got created::", countryCode)
              sessionStorage["geo_country_user"] = countryCode;
              sessionStorage["ipinfo_resp"] = JSON.stringify(resp);
              success(countryCode);
            });
        },

        // any initialisation options go here
      });
      //   console.log(iti);
      //   console.log(iti.getExtension());
      //   console.log(iti.getNumber());

      //   console.log("This is the second country code that got created::", countryCode);
      var iti_dropdown_elems = document.getElementsByClassName("iti--allow-dropdown");
      for (var j = 0; j < iti_dropdown_elems.length; j++) {
        iti_dropdown_elems[j].style.width = "100%";
      }
      var phone_number_input_elems = document.getElementsByClassName("phone_number_input");
      for (var k = 0; k < phone_number_input_elems.length; k++) {
        phone_number_input_elems[k].style.height = "62px";
      }
    }
  }

  activateToolTips() {
    $('[data-toggle="tooltip"]').tooltip({
      placement: "top",
    });
  }

  clearCookies() {
    // Using a different variant in logout. Can merge.
    var cookies = document.cookie;

    for (var i = 0; i < cookies.split(";").length; ++i) {
      var myCookie = cookies[i];
      var pos = myCookie.indexOf("=");
      var name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  clearStoragesandReload() {
    localStorage.clear();
    sessionStorage.clear();
    new UtilityFunctions().clearCookies();
    location.reload();
  }

  pageBack() {
    console.log("pageBack FUNCTION CALLED");
    var previous_pages_list = sessionStorage["navigation_history"].split(",");
    console.log(previous_pages_list);
    var previous_page = previous_pages_list[previous_pages_list.length - 2];
    console.log(previous_page);
    if (previous_pages_list.slice(0, -2).length == 0) {
      window.history.back();
    } else {
      console.log(previous_page.length);
      new PageContents().changePage(previous_page);
    }
  }

  parseCSV(csvText) {
    console.log("Got to parse CSV::", csvText);
    // Use PapaParse to parse the CSV text into an array of arrays
    var parsedData = Papa.parse(csvText, {
      header: true, // Set this to false if your CSV has no header row
      skipEmptyLines: true, // Skip empty lines in the CSV
    });

    return parsedData.data;
  }

  parseExcel(excelData) {
    console.log("Got to parse Excel::");
    // Parse the Excel data using xlsx library
    var workbook = XLSX.read(excelData, { type: "binary" });
    console.log(workbook);
    if (workbook.SheetNames.includes("Pipeline Submissions")) {
      // This is directly from a ciepal submission
      console.log("This is directly a ciepal pipeline");
      // Parse the 'Pipeline Submissions' sheet
      var pipelineSubmissionsSheet = workbook.Sheets["Pipeline Submissions"];
      var pipelineSubmissionsData = XLSX.utils.sheet_to_json(pipelineSubmissionsSheet, { header: 1 });
      pipelineSubmissionsData = pipelineSubmissionsData.slice(1, pipelineSubmissionsData.length);
      // Parse the 'Work Experience' sheet
      var workExperienceSheet = workbook.Sheets["Work Experience"];
      var workExperienceData = XLSX.utils.sheet_to_json(workExperienceSheet, {
        header: 1,
      });
      workExperienceData = workExperienceData.slice(1, workExperienceData.length);
      // Merge the two datasets
      var mergedData = [];
      console.log("Number of keys in pipelineSubmissionsData::", pipelineSubmissionsData[0].length);
      // debugger;
      for (var i = 0; i < pipelineSubmissionsData.length; i++) {
        var pipelineSubmission = pipelineSubmissionsData[i];
        // Find the first work experience entry
        var firstWorkExperience = workExperienceData.find(function (workExperience) {
          return workExperience[1] === pipelineSubmission[1];
        });
        // Add the first work experience to the pipeline submission entry
        if (firstWorkExperience) {
          pipelineSubmission.push(firstWorkExperience[2]);
          pipelineSubmission.push(firstWorkExperience[3]);
          pipelineSubmission.push(firstWorkExperience[4]);
        }
        // Add the merged entry to the mergedData array
        mergedData.push(pipelineSubmission);
      }
      console.log("This is the merged data!!, ", mergedData);
      console.log("Number of keys in mergedData::", mergedData[0].length);
      filteredExcelDataJson = mergedData;
    } else {
      // Assuming the first sheet is the one you want to parse
      var sheetName = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[sheetName];
      console.log(worksheet);
      // Convert the worksheet data into a JSON object
      var excelDataJson = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      console.log(excelDataJson);
      // Remove empty rows and columns (optional)
      var filteredExcelDataJson = excelDataJson.filter((row) => row.filter((cell) => cell !== "").length > 0);
      console.log(filteredExcelDataJson);
    }
    console.log("Final::", filteredExcelDataJson);
    return filteredExcelDataJson;
  }
  // Function to convert the array to JSON
  arrayToJSON(data) {
    const headers = data[0];
    const result = [];
    for (let i = 1; i < data.length; i++) {
      const obj = {};
      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = data[i][j];
      }
      result.push(obj);
    }

    return result;
  }

  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  getOrgChartFocusRootNode(diagram) {
    var d = diagram || (typeof myDiagram !== "undefined" ? myDiagram : null);
    if (!d) return null;
    try {
      var ceo = d.findNodesByExample({ std_function: "ceo", std_grade: "ceo" }).first();
      if (ceo) return ceo;
    } catch (e) {}
    try {
      var tr = d.findTreeRoots().first();
      if (tr) return tr;
    } catch (e2) {}
    try {
      return d.findNodeForKey(100000) || d.findNodeForKey(10000) || null;
    } catch (e3) {
      return null;
    }
  }

  /** Zoom in on CEO / root and center (legacy org chart behavior; not full zoomToFit). */
  centerViewportOnOrgChartRoot() {
    var diagram = typeof myDiagram !== "undefined" && myDiagram ? myDiagram : typeof window !== "undefined" ? window.myDiagram : null;
    if (!diagram) return;
    var root = this.getOrgChartFocusRootNode(diagram);
    if (!root) {
      diagram.commandHandler.zoomToFit();
      return;
    }
    diagram.zoomToRect(root.actualBounds);
    diagram.centerRect(root.actualBounds);
    diagram.commandHandler.decreaseZoom(0.3);
  }

  zoomToRect() {
    this.centerViewportOnOrgChartRoot();
  }

  scrollToPart() {
    this.centerViewportOnOrgChartRoot();
  }

  decreaseZoom() {
    var diagram = typeof myDiagram !== "undefined" && myDiagram ? myDiagram : typeof window !== "undefined" ? window.myDiagram : null;
    if (diagram) diagram.commandHandler.decreaseZoom(0.3);
  }

  // Adds tag to the invite friends email referred when space or tab is pressed
  addPromptEnumListTag() {
    console.log("addPromptEnumListTag FUNCTION CALLED");
    //Take the value from text input
    var tag = $("#prompt_enum_textarea").val();
    //Clear the text input and add tag
    $("#prompt_enum_textarea").val("").textext()[0].tags().addTags([tag]);
    new SessionStorageUpdates().updatePromptEnumTextareaList();
  }

  runWalkThrough() {
    if (sessionStorage["walkthrough"] == "yes") {
      console.log("THIS IS THE WALK THROUGHT ", sessionStorage["walkthrough"] == "yes");
      sessionStorage["walkthrough"] = "no";
      introJs()
        .onchange(function (targetElement) {
          console.log("This is the target element", targetElement);
          console.log("This is the current step called");
          console.log(this._currentStep);
          console.log("This is the current step", this._currentStep);
          if (this._currentStep == 2) {
            new NavTogglesCloses().toggleNav();
          } else if (this._currentStep == 3) {
            //  toggleNav()
          }
        })
        .start();
      console.log("This is introjs onchange start");
      // introJs().setOptions({
      //     steps: [{
      //       title: 'Welcome to the panda world',
      //       intro: 'Hello World! 👋'
      //     },
      //     {
      //       element: document.querySelector('.card-demo'),
      //       intro: 'This <b>STEP</b> focuses on an image. <br/> We also used some HTML tags!'
      //     },
      //     {
      //       title: 'Farewell!',
      //       element: document.querySelector('.card__image'),
      //       intro: '<img src="https://images.unsplash.com/photo-1608096299210-db7e38487075?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80" />'
      //     }]
      //   }).start();

      introJs().start();
    }
  }

  openHelpModal() {
    console.log("openHelpModal FUNCTION CALLED");

    $(help_modal).modal("show");
    document.getElementById("helper_image").innerHTML = '<img style="width:600px;" src="/static/img/load_org_chart.gif"/>';
    document.getElementById("helper_description").innerHTML = "Use the top search bar or the home page search bar and search company name. Filter the org chart by country or function using the dropdown options";
    document.getElementById("helper_list_container").innerHTML = document.getElementById("helper_list_element").innerHTML;
    $("#load_org_chart_helper").toggleClass("account_row account_row-selected");
  }

  closeHelpModal() {
    console.log("closeHelpModal FUNCTION CALLED");

    $(help_modal).modal("hide");
  }

  swapHelper(user_input) {
    console.log("swapHelper FUNCTION CALLED");

    var help = user_input.getAttribute("help");

    if (help == "load_org_chart") {
      document.getElementById("helper_image").innerHTML = '<img style="width:600px;" src="/static/img/load_org_chart.gif"/>';
      document.getElementById("helper_description").innerHTML = "Use the top search bar or the home page search bar and search company name. Filter the org chart by country or function using the dropdown options";
    } else if (help == "find_people") {
      document.getElementById("helper_image").innerHTML = '<img style="width:600px;" src="/static/img/fetch_positions.gif"/>';
      document.getElementById("helper_description").innerHTML = "Move to positions using the botton search bar and navigate buttons.<br> To fetch names, either double click and fetch all profiles or right click to fetch specific profiles";
    } else if (help == "similar_people") {
      document.getElementById("helper_image").innerHTML = '<img style="width:600px;" src="/static/img/similar_people_similar_companies.gif"/>';
      document.getElementById("helper_description").innerHTML = 'Right-click on a position and select "Fetch similar people in similar companies"';
    } else if (help == "find_people_company") {
      document.getElementById("helper_image").innerHTML = '<img style="width:600px;" src="/static/img/search_people_companies.gif"/>';
      document.getElementById("helper_description").innerHTML = "Go to the companies or people tab and use any of the left panel filters to filter through the databases";
    } else if (help == "find_people_title") {
      document.getElementById("helper_image").innerHTML = '<img style="width:600px;" src="/static/img/share.gif"/>';
      document.getElementById("helper_description").innerHTML = "Click on share and get a link you can share with friends and colleagues<br>(even if they are not Arxena users!)";
    } else if (help == "upgrade_plan") {
      document.getElementById("helper_image").innerHTML = '<img style="width:600px;" src="/static/img/make_payment.gif"/>';
      document.getElementById("helper_description").innerHTML = "Go to dashboard and select the plan or credits you wish to upgrade";
    }

    document.getElementById("helper_list_container").innerHTML = document.getElementById("helper_list_element").innerHTML;
    $("#" + help + "_helper").toggleClass("account_row account_row-selected");
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  capitalizeEachWord(str) {
    console.log("capitalizeEachWord FUNCTION CALLED");

    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
  }

  getLinkedinUrl(person_name, job_title, url, image) {
    console.log("getLinkedinUrl FUNCTION CALLED");
    console.log("person_name, job_title, url::", person_name, job_title, url);
    window.open(url, "_blank");

    // $('.modal').modal('hide');

    // if(sessionStorage['panel_preexisting']=='') {
    //     // console.log("setting panel preexisting popopopo")
    //     sessionStorage['panel_preexisting'] = document.getElementById("inside_panel_content_container").innerHTML
    // }

    // document.getElementById("inside_panel_content_container").innerHTML = document.getElementById("inside_panel_content_person_element").innerHTML
    // document.getElementById("inside_panel_content_container_mobi").innerHTML = document.getElementById("inside_panel_content_person_element").innerHTML
    // if (sessionStorage['lateral_bar'] != 'open'){
    // 	toggleNav()
    // }
    // sessionStorage['current_linkedin_link'] = ''

    // document.getElementById("loading_icon").innerHTML = ''
    // document.getElementById("person_photo").src = 'https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg'
    // document.getElementById("person_name").innerHTML = person_name
    // document.getElementById("person_job_title").innerHTML = job_title
    // document.getElementById("linkedin_profile").innerHTML = '<img src="/static/img/linkedin-icon-png-circle-2.png" style="height:20px; width:20px;margin-bottom:5px">'
    // $("#linkedin_profile").attr("href", url)
    // document.getElementById("load_contacts_button_container").innerHTML = '<div style="width:130px; margin-left:40px;" class="small_button_white" onclick="loadContacts()">Load Contacts</div>'
    // sessionStorage['current_linkedin_link'] = url
  }

  openExportPanel(user_input) {
    console.log("openExportPanel FUNCTION CALLED");

    var pages_list = sessionStorage["navigation_history"].split(",");
    var current_page = pages_list[pages_list.length - 1];

    // if (current_page == '/share') {
    //     accessAfterShare()
    // } else {
    // if(sessionStorage['panel_preexisting']=='') {
    // sessionStorage['panel_preexisting'] = document.getElementById("inside_panel_content_container").innerHTML
    // }
    console.log("Setting value of inside panel content container");
    // document.getElementById("inside_panel_content_container").innerHTML = document.getElementById("inside_panel_export_element").innerHTML
    sessionStorage["export_panel"] = document.getElementById("inside_panel_export_element").innerHTML;
    if (sessionStorage["lateral_bar"] != "open") {
      new NavTogglesCloses().toggleNav(user_input);
    }

    // }
  }

  async get_gpt_cost_by_token(chipText = "", isStandardProcess = false) {
    console.log({ isStandardProcess });
    let output_option = null;
    let question_prompt = null;
    let columns = [];
    let gpt_cost_compute_element = null;
    if (isStandardProcess) {
      gpt_cost_compute_element = document.getElementById("gpt_cost_compute_element_standard");
      gpt_cost_compute_element.style.display = "";
      gpt_cost_compute_element.innerText = "Loading...";

      let gpt_table_prompts = JSON.parse(sessionStorage["gpt_table_prompts"]);
      columns = gpt_table_prompts.filter((GPTPrompt) => GPTPrompt.prompt != "").map((matchedPrompt) => matchedPrompt.data);
      columns = ["_id", ...columns];
    } else {
      gpt_cost_compute_element = document.getElementById("gpt_cost_compute_element");
      gpt_cost_compute_element.style.display = "";
      gpt_cost_compute_element.innerText = "Loading...";

      question_prompt = document.getElementById("input_prompt_base_filter_text").value;
      output_option = $("#prompt_enum_textarea")?.textext()[0]?.tags()["_formData"];
      let selectDropDownColumn = new Components().getAllSelectedFields("selected_option_chips");
      console.log("{selectDropDownColumn}");
      console.log({ selectDropDownColumn });
      if (chipText) {
        if (selectDropDownColumn?.length == 0) {
          selectDropDownColumn.push(chipText);
        }
        if (!selectDropDownColumn.includes(chipText)) {
          selectDropDownColumn.push(chipText);
        }
      }
      columns = gpt_prompts.filter((prompt) => selectDropDownColumn.includes(prompt.field)).map((matchedPrompt) => matchedPrompt.data);
      columns = ["_id", ...columns];
    }
    let hot = hotInstance.getHotInstance();
    let candidate_details = new LeftPanelTableActions().getSelectedCandidateDetailsFromHOT(hot, columns);
    console.log("These are the candidate details::", candidate_details);
    candidate_details = candidate_details.filter((detail) => detail != null && detail._id != null).map(({ _id, ...rest }) => rest);
    console.log(candidate_details);
    let valuesArray = [];
    if (!!candidate_details && candidate_details?.length > 0) {
      valuesArray = candidate_details.map((item) => Object.values(item)).flat();
      if (output_option && question_prompt) {
        output_option.forEach((x) => valuesArray.push(x));
        valuesArray.push(question_prompt);
      }
      let requestBody = { tokens: valuesArray };

      try {
        const response = await AjaxAPICall(eUrl.gptCost, eMethod.post, requestBody);
        if (response["status"] == "ok") {
          let cost = response["request_cost"];
          let total_tokens = response["total_tokens"];
          let GPT_model = response["GPT_model"];
          sessionStorage["total_tokens"] = total_tokens;
          gpt_cost_compute_element.innerHTML = `The approx cost for process is ${cost} credits`;
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      console.log("no records selected in get_gpt_cost_by_token");
      gpt_cost_compute_element.innerHTML = `please select records`;
    }
  }

  onkeyPressCallGPTCostAPI() {
    clearTimeout(delayTimer);
    delayTimer = setTimeout(this.get_gpt_cost_by_token, 1000);
  }
}

function loadJs(id, url = null, inlineScript = null, callback) {
  console.log("loadJs FUNCTION CALLED");

  var e = document.createElement("script");

  if (url) e.src = url;

  if (inlineScript) e.appendChild(document.createTextNode(inlineScript));

  e.type = "text/javascript";
  e.id = id;
  e.defer = true;
  e.addEventListener("load", callback);
  document.getElementsByTagName("head")[0].appendChild(e);
}

loadJs("cookies-api", "https://cdnjs.cloudflare.com/ajax/libs/js-cookie/2.2.1/js.cookie.min.js", null, function () {
  console.log("loadjs FUNCTION CALLED for js cookie");
  if (Cookies.get("name")) {
    var name = Cookies.get("name");
  }
});

$(document).ready(function () {
  $("#du-button-files").click(function () {
    $("#open-file").click();
  });

  $("#database-costs").DataTable({
    searching: false,
    paging: false,
    info: false,
    ordering: false,
  });
  $("#premium-fields").DataTable({
    searching: false,
    paging: false,
    info: false,
    ordering: false,
  });
  $("input[type='search']").wrap("<form>");
  $("input[type='search']").closest("form").attr("autocomplete", "off");

  new UtilityFunctions().getCountryCode();
  loadTawkWidget();
  setTimeout("removeTalkWidgetBrand();", 500);

  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

  // console.log("This is the viewport data ::Height::", vh);
  // console.log("This is the viewport data ::Width::", vw);
  // Temporarily disabling error messaging
  // window.onerror = function(message, source, lineno, colno, error) {
  //     error_message = error['message']
  //     error_stack = error['stack']
  //     error_obj =  {message:message, source:source, lineno:lineno,colno:colno, error:error, error_message:error_message, error_stack:error_stack,  user:localStorage['user']}
  //     // console.log(error_obj)
  //     $.ajax({
  //         url :'/error_message',
  //         type : 'POST',
  //         data : error_obj,
  //         }).done(function(data) {
  //             console.log("Error message sent and received this response::%s", data)
  //     });
  // };

  if (navigator.platform.indexOf("Win") > -1) {
    document.body.classList.add("windows");
  }
  new Iframes().getIframeLoaded();
});

console.log("Thisi s the max width");

export { UtilityFunctions, loadJs };
if (typeof window !== 'undefined') {
  window.UtilityFunctions = UtilityFunctions;
  window.loadJs = loadJs;
}
